// React Utils
import { Link } from "react-router-dom";
// Packages components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// Assets
import bckWoop from "@/assets/Logo-AppWhoop.webp"; // Placeholder image for lazy loading

// Utils
import { scrollToTop } from "@/lib/utilsUI";

export default function TicketCardPerfilEmpresa({ ticket }) {

  return (
    <div className="min-w-[200px] max-w-[200px] bg-aw-bluedark rounded-b-xl shadow-lg overflow-hidden">
      {/* Imagen del Ticket */}
      <Link
        to={ticket.id != null? `/evento/${ticket.id}` : "#"}
        onClick={ticket.id != null && scrollToTop}
        className="h-52 block overflow-hidden relative border-2 border-aw-green bg-aw-bluegray"
      >
        <img
          src={bckWoop} // Placeholder image for lazy loading
          alt="Placeholder"
          className="absolute inset-0 w-2/3 h-2/3 m-auto top-0 left-0 object-cover z-0"
        />
        <LazyLoadImage
          src={ticket.image} // Use the placeholder image
          placeholderSrc={bckWoop} // Placeholder image
          alt={ticket.title}
          height={"100%"}
          width={"100%"}
          effect="blur"
          className="w-full h-full object-cover z-50"
          loading="lazy"
        />
      </Link>
      <div className="px-2 py-1 flex flex-col justify-between h-[130px] text-center">
        <span className="text-tiny text-white">{ticket.dateTime}</span>
        <h3 className="font-bold text-sm text-white line-clamp-2">{ticket.title}</h3>
        {ticket.discount && (
          <span className="text-aw-green font-bold text-sm">
            Ticket con Descuento
          </span>
        )}
        <p className="text-xs text-gray-500 line-clamp-1">
          <FontAwesomeIcon
            icon="fa-solid fa-map-pin"
            className="text-red-700 mr-1"
          />
          {ticket.location}
        </p>
      </div>
      {/* Botón Comprar Ticket */}
      <Link
        to={ticket.id != null? `/evento/${ticket.id}` : "#"}
        onClick={ticket.id != null && scrollToTop}
        className="w-full h-9 flex items-center justify-center bg-aw-green text-black font-semibold text-sm mt-2 py-1 hover:scale-110 transition duration-300"
      >
        Comprar Ticket
        <FontAwesomeIcon
          icon="fa-solid fa-ticket"
          className="ml-2 -rotate-z-45"
        />
      </Link>
    </div>
  );
}
